export interface DailyQuoteEntry {
  text: string;
  author: string;
}

export const DAILY_QUOTES: DailyQuoteEntry[] = [
  { text: "Take care of your employees and they'll take care of your business.", author: "Richard Branson" },
  { text: "Clients do not come first. Employees come first. If you take care of your employees, they will take care of the clients.", author: "Richard Branson" },
  { text: "To win in the marketplace you must first win in the workplace.", author: "Doug Conant" },
  { text: "Your culture is your brand.", author: "Tony Hsieh" },
  { text: "The secret of getting ahead is getting started.", author: "Mark Twain" },
  { text: "People may hear your words, but they feel your culture.", author: "Oscar Auliq-Ice" },
  { text: "It's not the tools you have faith in — tools are just tools. It's the people you have faith in.", author: "Steve Jobs" },
  { text: "Great things in business are never done by one person; they're done by a team of people.", author: "Steve Jobs" },
  { text: "You don't build a business — you build people — and then people build the business.", author: "Zig Ziglar" },
  { text: "The strength of the team is each individual member. The strength of each member is the team.", author: "Phil Jackson" },
  { text: "Alone we can do so little; together we can do so much.", author: "Helen Keller" },
  { text: "Coming together is a beginning. Keeping together is progress. Working together is success.", author: "Henry Ford" },
  { text: "An investment in knowledge pays the best interest.", author: "Benjamin Franklin" },
  { text: "Success is not final, failure is not fatal: it is the courage to continue that counts.", author: "Winston Churchill" },
  { text: "The best way to find yourself is to lose yourself in the service of others.", author: "Mahatma Gandhi" },
  { text: "Leadership is not about being in charge. It is about taking care of those in your charge.", author: "Simon Sinek" },
  { text: "Train people well enough so they can leave, treat them well enough so they don't want to.", author: "Richard Branson" },
  { text: "Highly engaged teams show 21% greater profitability.", author: "Gallup Research" },
  { text: "Every accomplishment starts with the decision to try.", author: "John F. Kennedy" },
  { text: "The way to get started is to quit talking and begin doing.", author: "Walt Disney" },
  { text: "Happiness is not something ready-made. It comes from your own actions.", author: "Dalai Lama" },
  { text: "Do what you can, with what you have, where you are.", author: "Theodore Roosevelt" },
  { text: "Believe you can and you're halfway there.", author: "Theodore Roosevelt" },
  { text: "Act as if what you do makes a difference. It does.", author: "William James" },
  { text: "A good leader takes a little more than their share of the blame, a little less than their share of the credit.", author: "Arnold H. Glasgow" },
];

/** Returns the same quote for an entire calendar day, cycling through the list. */
export function getQuoteOfTheDay(): DailyQuoteEntry {
  const dateStr = new Date().toDateString(); // e.g. "Mon Apr 24 2026"
  const seed = dateStr.split("").reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  return DAILY_QUOTES[seed % DAILY_QUOTES.length];
}
